/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "UniqueTractCommentBehaviour" class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function UniqueTractCommentBehaviour() {
    /// <summary>
    /// Behaviour ensuring a value is unique
    /// </summary>
    this.defer = true;
}

//-------------------------------------------
UniqueTractCommentBehaviour.prototype.validate = function uniqueTractCommentBehaviourValidate(value) {
    var editGridRef = this.behaviourData && this.behaviourData.editGridRef;
    var viewItem = editGridRef.viewItem.peek();

    if (ko.isObservable(editGridRef.items)) {
        var items = editGridRef.items.peek(),
            commentItems = ko.utils.arrayFilter(items, function (item) {
                if (item.guid) {
                    return item.type === "comment" && item.tractNumber === value && item.guid !== viewItem.guid.peek();
                }

                return item.type === "comment" && item.tractNumber === value && item.rowId !== viewItem.rowId.peek();

            }, this);

        if (commentItems && commentItems.length > 0) {
            return "Only one comment per group is allowed";
        }
    }

    return null;
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Export
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = new UniqueTractCommentBehaviour();



//////////////////
// WEBPACK FOOTER
// ./app/ko-behaviours-uniquetractcomment/uniqueTractComment.js
// module id = 563
// module chunks = 49